import React from "react";
import styles from "./LocalRecommendations.module.scss";
import RainbowStreet from "../../icons/RainbowStreet";
import Sculpture from "../../icons/Sculpture";

const LocalRecommendations = () => {
  return (
    <div className={styles.container}>
      <div className={styles.firstSection}>
        <div className={styles.headerWrapper}>
          <h1 className={styles.header}>Local Recommendations</h1>
        </div>
      </div>

      <div className={styles.content}>
        <section className={styles.section}>
          <h2>Sights & Walks</h2>
          <div className={styles.papersWrapper}>
            <div className={styles.papersBlurb}>
              <div className={styles.infoSection}>
                <h3>Hólavallagarður and the Pond</h3>
                <p>
                  Hólavallagarður is the second oldest graveyard in Reykjavík
                  (1838–1932) and is covered in beautiful flora and old graves.
                  It's right next to the university campus and offers a
                  beautiful, tranquil space to walk around. There one will find
                  memorials to a few famous Icelanders with informational
                  plaques. Going downtown from there, you go past the city pond
                  that is brimming with bird life at this time of year.
                </p>
              </div>

              <div className={styles.infoSection}>
                <h3>The Rainbow Street</h3>
                <p>
                  When downtown we recommend a walk up Skólavörðustígur, better
                  known as the rainbow street. There are many shops, cafés,
                  restaurants and bars along that street, one of them being{" "}
                  <strong>12 tónar</strong>, a record shop, bar and café. There
                  one can find a wide selection of both new and used records.
                  The store was founded in 1998 and has since become the
                  country's most popular record shop. It's also a lovely spot to
                  sit down and have a drink, with a good selection of coffee,
                  tea, and beer. If you're there before 18:00 you can also pop
                  in to <strong>Handprjónasambandið</strong> (Handknitting
                  Association) and buy a handmade Icelandic sweater.
                </p>
                <RainbowStreet />
              </div>

              <div className={styles.infoSection}>
                <h3>Hallgrímskirkja / Skólavörðuholt</h3>
                <p>
                  At the end of the rainbow street stands Hallgrímskirkja, the
                  large church visible from campus. It is possible to go up to
                  the tower for a fee, but it can also be really nice to simply
                  walk around the church and the surrounding area.
                </p>
              </div>

              <div className={styles.infoSection}>
                <h3>Seaside Walk</h3>
                <p>
                  Enjoy the evening sun and views of the mountain Esja. Visit
                  the famous sculpture <strong>Sólfarið</strong> (Sun Voyager),
                  or walk around the old harbour and visit{" "}
                  <strong>Þúfan</strong> by Ólöf Nordal, celebrating the old
                  Icelandic tradition of drying fish by the seaside.
                </p>
                <Sculpture />
              </div>
            </div>
          </div>
        </section>

        <section className={styles.section}>
          <h2>Events — June 15th</h2>
          <div className={styles.papersWrapper}>
            <div className={styles.papersBlurb}>
              <div className={styles.infoSection}>
                <h3>Mánudjass – LeKock</h3>
                <p>
                  At 20:00 on June 15th there is a free jazz concert at the
                  restaurant and bar <strong>LeKock</strong>, located at
                  Tryggvagata 14, close to the old harbour and Hafnarhúsið. On
                  your way there we recommend walking through the{" "}
                  <em>"rock village"</em>, a historic neighbourhood in
                  Reykjavík. If you need a new perfume for the Conference
                  Closing event, a good place to look is{" "}
                  <strong>Fischersund</strong> in the village.
                </p>
              </div>

              <div className={styles.infoSection}>
                <h3>Bíó Paradís</h3>
                <p>
                  Showing of the FIFA World Cup on June 15th — free entry. Bíó
                  Paradís is an old movie theater in downtown Reykjavík that
                  often shows artistic and international films and hosts film
                  festivals. They also have a bar on site.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className={styles.section}>
          <h2>Food, Drink & Pools</h2>
          <div className={styles.papersWrapper}>
            <div className={styles.papersBlurb}>
              <div className={styles.infoSection}>
                <h3>Public Pools</h3>
                <p>
                  <strong>Vesturbæjarlaug</strong> is the closest public pool to
                  the university area and has a newly refurbished sauna area
                  with dry sauna, infrared sauna, and a beautiful steam bath,
                  swimming pool and plenty of hot tubs.{" "}
                  <strong>Seltjarnarneslaug</strong> is another option close by
                  with views out to the ocean, and{" "}
                  <strong>Laugardalslaug</strong> is one of the most popular
                  pools for good reason.
                </p>
              </div>

              <div className={styles.infoSection}>
                <h3>Pub Crawl</h3>
                <p>
                  Start with <strong>Skúli</strong>, a craft beer bar located in
                  a historic plaza near the oldest cemetery in Reykjavík. Then
                  walk to <strong>Ægir</strong>, a folklorist favourite
                  microbrewery with historical themes — try the national food if
                  you're feeling brave! If you want a quieter experience with
                  fine wines, <strong>Port 9</strong>'s sommeliers can bring you
                  exactly what you need, and if the weather is nice you can sit
                  up on the roof. Lastly, <strong>22</strong> is a historic
                  LGBTQIA+ bar with cocktails and beer.
                </p>
              </div>

              <div className={styles.infoSection}>
                <h3>Restaurants</h3>
                <p>
                  On campus you can find <strong>Stúdentakjallarinn</strong>{" "}
                  (the Student Cellar), which is both affordable and good. You
                  could also try some locally inspired small plates at the old
                  West Side's <strong>Forréttabar</strong>. The langoustine
                  soups at the <strong>Sea Baron</strong> in the old harbour
                  area are also a big draw. Close by you can get a taste of
                  Napoli in Reykjavík at the popular <strong>Flatey</strong>{" "}
                  pizza. Alternatively, walk downtown for a slice of pizza and
                  more at one of the oldest restaurants, <strong>Hornið</strong>
                  . Food courts are numerous and spacious throughout the city,
                  including <strong>Grandi Mathöll</strong> and{" "}
                  <strong>Hafnartorg</strong> at the harbour,{" "}
                  <strong>Pósthús Food & Bar</strong> near the town square, and{" "}
                  <strong>Hlemmur Mathöll</strong> at the east end of the main
                  shopping street Laugavegur. The brave can grab a garlic burger
                  — or a Forget-me-not — at the formidable{" "}
                  <strong>Vitabar</strong>.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default LocalRecommendations;
